import { render, staticRenderFns } from "./ShipmentItem.vue?vue&type=template&id=d22d06e8&scoped=true"
import script from "./ShipmentItem.vue?vue&type=script&lang=js"
export * from "./ShipmentItem.vue?vue&type=script&lang=js"
import style0 from "./ShipmentItem.vue?vue&type=style&index=0&id=d22d06e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22d06e8",
  null
  
)

export default component.exports